
const TermOfUse = () => {
    return (
        <div className="pdf-viewer" style={{ display: "flex", justifyContent: "center", height: "100%", overflow: "hidden", marginBottom: "60px", marginTop: "160px" }}>
            <iframe
                src="/raw/Terms%20of%20Use.pdf"
                width="100%"
                height="900px"
                style={{ border: 'none', maxWidth: "1200px" }}
                title="Privacy Policy PDF"
            />
        </div>
    );
};

export default TermOfUse;
